module.exports = __webpack_public_path__ + "static/media/3.5c38f121.jpg";